export const SET_ZONE_EXPIRATION = 'SET_ZONE_EXPIRATION';
export const ZONE_EXPIRATION_DIALOG_MODE = 'ZONE_EXPIRATION_DIALOG_MODE';
export const OPEN_DIALOG_ZONE_EXPIRATION = 'OPEN_DIALOG_ZONE_EXPIRATION';
